// Complete Pokemon Champions move database
// Source: serebii.net/attackdex-champions
// Excludes Z-Moves, Max Moves, G-Max moves, and Let's Go exclusive moves

const MOVE_TYPES = {
  'Absorb': 'Grass', 'Accelerock': 'Rock', 'Acid': 'Poison', 'Acid Armor': null,
  'Acid Spray': 'Poison', 'Acrobatics': 'Flying', 'Acupressure': null, 'Aerial Ace': 'Flying',
  'After You': null, 'Agility': null, 'Air Cutter': 'Flying', 'Air Slash': 'Flying',
  'Alluring Voice': 'Fairy', 'Ally Switch': null, 'Amnesia': null, 'Anchor Shot': 'Steel',
  'Ancient Power': 'Rock', 'Apple Acid': 'Grass', 'Aqua Cutter': 'Water', 'Aqua Jet': 'Water',
  'Aqua Ring': null, 'Aqua Step': 'Water', 'Aqua Tail': 'Water', 'Arm Thrust': 'Fighting',
  'Armor Cannon': 'Fire', 'Aromatherapy': null, 'Aromatic Mist': null, 'Assurance': 'Dark',
  'Astonish': 'Ghost', 'Attract': null, 'Aura Sphere': 'Fighting', 'Aura Wheel': 'Electric',
  'Aurora Veil': null, 'Avalanche': 'Ice', 'Axe Kick': 'Fighting',

  'Baby-Doll Eyes': null, 'Baneful Bunker': null, 'Barrage': 'Normal', 'Barrier': null,
  'Baton Pass': null, 'Beak Blast': 'Flying', 'Beat Up': 'Dark', 'Belch': 'Poison',
  'Belly Drum': null, 'Bind': 'Normal', 'Bite': 'Dark', 'Bitter Blade': 'Fire',
  'Bitter Malice': 'Ghost', 'Blast Burn': 'Fire', 'Blaze Kick': 'Fire', 'Bleakwind Storm': 'Flying',
  'Blizzard': 'Ice', 'Block': null, 'Blood Moon': 'Normal', 'Blue Flare': 'Fire',
  'Body Press': 'Fighting', 'Body Slam': 'Normal', 'Bolt Beak': 'Electric', 'Bolt Strike': 'Electric',
  'Bone Rush': 'Ground', 'Boomburst': 'Normal', 'Bounce': 'Flying', 'Brave Bird': 'Flying',
  'Breaking Swipe': 'Dragon', 'Brick Break': 'Fighting', 'Brine': 'Water', 'Brutal Swing': 'Dark',
  'Bug Bite': 'Bug', 'Bug Buzz': 'Bug', 'Bulk Up': null, 'Bulldoze': 'Ground',
  'Bullet Punch': 'Steel', 'Bullet Seed': 'Grass', 'Burn Up': 'Fire', 'Burning Jealousy': 'Fire',

  'Calm Mind': null, 'Ceaseless Edge': 'Dark', 'Charge': null, 'Charge Beam': 'Electric',
  'Charm': null, 'Chilling Water': 'Water', 'Chilly Reception': null, 'Circle Throw': 'Fighting',
  'Clanging Scales': 'Dragon', 'Clangorous Soul': null, 'Clear Smog': 'Poison',
  'Close Combat': 'Fighting', 'Coaching': null, 'Coil': null, 'Collision Course': 'Fighting',
  'Comeuppance': 'Dark', 'Confuse Ray': null, 'Copycat': null, 'Core Enforcer': 'Dragon',
  'Corrosive Gas': null, 'Cosmic Power': null, 'Cotton Guard': null, 'Cotton Spore': null,
  'Counter': 'Fighting', 'Covet': 'Normal', 'Crabhammer': 'Water', 'Cross Chop': 'Fighting',
  'Cross Poison': 'Poison', 'Crunch': 'Dark', 'Crush Claw': 'Normal', 'Curse': null,

  'Dark Pulse': 'Dark', 'Darkest Lariat': 'Dark', 'Dazzling Gleam': 'Fairy', 'Decorate': null,
  'Defog': null, 'Destiny Bond': null, 'Detect': null, 'Dig': 'Ground', 'Dire Claw': 'Poison',
  'Disable': null, 'Discharge': 'Electric', 'Dive': 'Water', 'Double Hit': 'Normal',
  'Double Iron Bash': 'Steel', 'Double Kick': 'Fighting', 'Double Team': null,
  'Double-Edge': 'Normal', 'Draco Meteor': 'Dragon', 'Dragon Breath': 'Dragon',
  'Dragon Cheer': null, 'Dragon Claw': 'Dragon', 'Dragon Dance': null, 'Dragon Darts': 'Dragon',
  'Dragon Energy': 'Dragon', 'Dragon Hammer': 'Dragon', 'Dragon Pulse': 'Dragon',
  'Dragon Rush': 'Dragon', 'Dragon Tail': 'Dragon', 'Drain Punch': 'Fighting',
  'Draining Kiss': 'Fairy', 'Drill Peck': 'Flying', 'Drill Run': 'Ground',
  'Drum Beating': 'Grass', 'Dual Chop': 'Dragon', 'Dual Wingbeat': 'Flying',
  'Dynamic Punch': 'Fighting',

  'Earth Power': 'Ground', 'Earthquake': 'Ground', 'Eerie Impulse': null, 'Eerie Spell': 'Psychic',
  'Electric Terrain': null, 'Electrify': null, 'Electro Ball': 'Electric',
  'Electro Drift': 'Electric', 'Electro Shot': 'Electric', 'Electroweb': 'Electric',
  'Encore': null, 'Endeavor': 'Normal', 'Endure': null, 'Energy Ball': 'Grass',
  'Entrainment': null, 'Eruption': 'Fire', 'Esper Wing': 'Psychic', 'Expanding Force': 'Psychic',
  'Explosion': 'Normal', 'Extrasensory': 'Psychic', 'Extreme Speed': 'Normal',

  'Facade': 'Normal', 'Fairy Lock': null, 'Fairy Wind': 'Fairy', 'Fake Out': 'Normal',
  'Fake Tears': null, 'False Surrender': 'Dark', 'False Swipe': 'Normal', 'Feather Dance': null,
  'Feint': 'Normal', 'Fell Stinger': 'Bug', 'Fickle Beam': 'Dragon', 'Fiery Dance': 'Fire',
  'Fiery Wrath': 'Dark', 'Fillet Away': null, 'Final Gambit': 'Fighting', 'Fire Blast': 'Fire',
  'Fire Fang': 'Fire', 'Fire Lash': 'Fire', 'Fire Pledge': 'Fire', 'Fire Punch': 'Fire',
  'Fire Spin': 'Fire', 'First Impression': 'Bug', 'Fishious Rend': 'Water', 'Fissure': 'Ground',
  'Flail': 'Normal', 'Flame Charge': 'Fire', 'Flame Wheel': 'Fire', 'Flamethrower': 'Fire',
  'Flare Blitz': 'Fire', 'Flash Cannon': 'Steel', 'Flatter': null, 'Fling': 'Dark',
  'Flip Turn': 'Water', 'Flower Trick': 'Grass', 'Fly': 'Flying', 'Flying Press': 'Fighting',
  'Focus Blast': 'Fighting', 'Focus Energy': null, 'Focus Punch': 'Fighting',
  'Follow Me': null, 'Force Palm': 'Fighting', "Forest's Curse": null, 'Foul Play': 'Dark',
  'Freeze-Dry': 'Ice', 'Frenzy Plant': 'Grass', 'Frost Breath': 'Ice', 'Future Sight': 'Psychic',

  'Gastro Acid': null, 'Gear Grind': 'Steel', 'Giga Drain': 'Grass', 'Giga Impact': 'Normal',
  'Gigaton Hammer': 'Steel', 'Glacial Lance': 'Ice', 'Glaive Rush': 'Dragon', 'Glare': null,
  'Grass Knot': 'Grass', 'Grass Pledge': 'Grass', 'Grassy Glide': 'Grass', 'Grassy Terrain': null,
  'Grav Apple': 'Grass', 'Gravity': null, 'Growl': null, 'Growth': null,
  'Guard Split': null, 'Guard Swap': null, 'Guillotine': 'Normal', 'Gunk Shot': 'Poison',
  'Gust': 'Flying', 'Gyro Ball': 'Steel',

  'Hail': null, 'Hammer Arm': 'Fighting', 'Hard Press': 'Steel', 'Harden': null, 'Haze': null,
  'Head Charge': 'Normal', 'Head Smash': 'Rock', 'Headbutt': 'Normal', 'Headlong Rush': 'Ground',
  'Heal Bell': null, 'Heal Pulse': null, 'Healing Wish': null, 'Heart Stamp': 'Psychic',
  'Heat Crash': 'Fire', 'Heat Wave': 'Fire', 'Heavy Slam': 'Steel', 'Helping Hand': null,
  'Hex': 'Ghost', 'High Horsepower': 'Ground', 'High Jump Kick': 'Fighting',
  'Hone Claws': null, 'Horn Attack': 'Normal', 'Horn Drill': 'Normal', 'Horn Leech': 'Grass',
  'Howl': null, 'Hurricane': 'Flying', 'Hydro Cannon': 'Water', 'Hydro Pump': 'Water',
  'Hydro Steam': 'Water', 'Hyper Beam': 'Normal', 'Hyper Drill': 'Normal',
  'Hyper Voice': 'Normal', 'Hypnosis': null,

  'Ice Beam': 'Ice', 'Ice Fang': 'Ice', 'Ice Hammer': 'Ice', 'Ice Punch': 'Ice',
  'Ice Shard': 'Ice', 'Ice Spinner': 'Ice', 'Icicle Crash': 'Ice', 'Icicle Spear': 'Ice',
  'Icy Wind': 'Ice', 'Imprison': null, 'Infernal Parade': 'Ghost', 'Inferno': 'Fire',
  'Infestation': 'Bug', 'Ingrain': null, 'Instruct': null, 'Iron Defense': null,
  'Iron Head': 'Steel', 'Iron Tail': 'Steel', 'Ivy Cudgel': 'Grass',

  'Jaw Lock': 'Dark', 'Jet Punch': 'Water', 'Jump Kick': 'Fighting',

  "King's Shield": null, 'Knock Off': 'Dark', 'Kowtow Cleave': 'Dark',

  'Lash Out': 'Dark', 'Last Resort': 'Normal', 'Last Respects': 'Ghost', 'Lava Plume': 'Fire',
  'Leaf Blade': 'Grass', 'Leaf Storm': 'Grass', 'Leaf Tornado': 'Grass', 'Leafage': 'Grass',
  'Leech Life': 'Bug', 'Leech Seed': null, 'Leer': null, 'Life Dew': null,
  'Light Screen': null, 'Light of Ruin': 'Fairy', 'Liquidation': 'Water', 'Low Kick': 'Fighting',
  'Low Sweep': 'Fighting', 'Lumina Crash': 'Psychic', 'Lunge': 'Bug',

  'Mach Punch': 'Fighting', 'Magic Coat': null, 'Magic Powder': null, 'Magic Room': null,
  'Magical Leaf': 'Grass', 'Magma Storm': 'Fire', 'Magnet Rise': null, 'Magnetic Flux': null,
  'Make It Rain': 'Steel', 'Matcha Gotcha': 'Grass', 'Mean Look': null, 'Mega Drain': 'Grass',
  'Mega Kick': 'Normal', 'Megahorn': 'Bug', 'Memento': null, 'Metal Burst': 'Steel',
  'Metal Claw': 'Steel', 'Metal Sound': null, 'Meteor Beam': 'Rock', 'Meteor Mash': 'Steel',
  'Mighty Cleave': 'Rock', 'Milk Drink': null, 'Minimize': null, 'Mirror Coat': null,
  'Misty Explosion': 'Fairy', 'Misty Terrain': null, 'Moonblast': 'Fairy', 'Moonlight': null,
  'Morning Sun': null, 'Mortal Spin': 'Poison', 'Mountain Gale': 'Ice', 'Mud Bomb': 'Ground',
  'Mud Shot': 'Ground', 'Mud-Slap': 'Ground', 'Muddy Water': 'Water', 'Mystical Fire': 'Fire',
  'Mystical Power': 'Psychic',

  'Nasty Plot': null, 'Night Daze': 'Dark', 'Night Shade': 'Ghost', 'Night Slash': 'Dark',
  'Noble Roar': null, 'No Retreat': null, 'Nuzzle': 'Electric',

  'Obstruct': null, 'Order Up': 'Dragon', 'Outrage': 'Dragon', 'Overdrive': 'Electric',
  'Overheat': 'Fire',

  'Pain Split': null, 'Parabolic Charge': 'Electric', 'Parting Shot': null, 'Payback': 'Dark',
  'Peck': 'Flying', 'Perish Song': null, 'Petal Blizzard': 'Grass', 'Petal Dance': 'Grass',
  'Phantom Force': 'Ghost', 'Pin Missile': 'Bug', 'Play Rough': 'Fairy', 'Pluck': 'Flying',
  'Poison Fang': 'Poison', 'Poison Gas': null, 'Poison Jab': 'Poison', 'Poison Powder': null,
  'Poison Sting': 'Poison', 'Poison Tail': 'Poison', 'Pollen Puff': 'Bug',
  'Poltergeist': 'Ghost', 'Population Bomb': 'Normal', 'Pounce': 'Bug', 'Pound': 'Normal',
  'Powder Snow': 'Ice', 'Power Gem': 'Rock', 'Power Shift': null, 'Power Split': null,
  'Power Swap': null, 'Power Trip': 'Dark', 'Power Whip': 'Grass', 'Power-Up Punch': 'Fighting',
  'Precipice Blades': 'Ground', 'Protect': null, 'Psybeam': 'Psychic', 'Psyblade': 'Psychic',
  'Psych Up': null, 'Psychic': 'Psychic', 'Psychic Fangs': 'Psychic', 'Psychic Noise': 'Psychic',
  'Psychic Terrain': null, 'Psycho Cut': 'Psychic', 'Psyshield Bash': 'Psychic',
  'Psyshock': 'Psychic', 'Pyro Ball': 'Fire',

  'Quash': null, 'Quick Attack': 'Normal', 'Quick Guard': null, 'Quiver Dance': null,

  'Rage': 'Normal', 'Rage Fist': 'Ghost', 'Rage Powder': null, 'Raging Bull': 'Normal',
  'Raging Fury': 'Fire', 'Rain Dance': null, 'Rapid Spin': 'Normal', 'Razor Leaf': 'Grass',
  'Razor Shell': 'Water', 'Recover': null, 'Recycle': null, 'Reflect': null,
  'Reflect Type': null, 'Rest': null, 'Retaliate': 'Normal', 'Return': 'Normal',
  'Revenge': 'Fighting', 'Reversal': 'Fighting', 'Revival Blessing': null,
  'Rising Voltage': 'Electric', 'Roar': null, 'Rock Blast': 'Rock', 'Rock Polish': null,
  'Rock Slide': 'Rock', 'Rock Smash': 'Fighting', 'Rock Throw': 'Rock', 'Rock Tomb': 'Rock',
  'Rock Wrecker': 'Rock', 'Role Play': null, 'Rolling Kick': 'Fighting', 'Rollout': 'Rock',
  'Roost': null, 'Round': 'Normal', 'Ruination': 'Dark',

  'Sacred Fire': 'Fire', 'Sacred Sword': 'Fighting', 'Safeguard': null, 'Salt Cure': 'Rock',
  'Sand Attack': null, 'Sand Tomb': 'Ground', 'Sandsear Storm': 'Ground', 'Sandstorm': null,
  'Scald': 'Water', 'Scale Shot': 'Dragon', 'Scary Face': null, 'Scorching Sands': 'Ground',
  'Scratch': 'Normal', 'Screech': null, 'Seed Bomb': 'Grass', 'Seed Flare': 'Grass',
  'Seismic Toss': 'Fighting', 'Self-Destruct': 'Normal', 'Shadow Ball': 'Ghost',
  'Shadow Bone': 'Ghost', 'Shadow Claw': 'Ghost', 'Shadow Force': 'Ghost',
  'Shadow Punch': 'Ghost', 'Shadow Sneak': 'Ghost', 'Shed Tail': null, 'Sheer Cold': 'Ice',
  'Shell Side Arm': 'Poison', 'Shell Smash': null, 'Shell Trap': 'Fire', 'Shelter': null,
  'Shift Gear': null, 'Signal Beam': 'Bug', 'Silk Trap': null, 'Silver Wind': 'Bug',
  'Simple Beam': null, 'Sing': null, 'Sketch': null, 'Skill Swap': null,
  'Skitter Smack': 'Bug', 'Skull Bash': 'Normal', 'Sky Attack': 'Flying', 'Sky Uppercut': 'Fighting',
  'Slack Off': null, 'Slam': 'Normal', 'Slash': 'Normal', 'Sleep Powder': null,
  'Sleep Talk': null, 'Sludge Bomb': 'Poison', 'Sludge Wave': 'Poison', 'Smack Down': 'Rock',
  'Smart Strike': 'Steel', 'Smog': 'Poison', 'Smokescreen': null, 'Snap Trap': 'Grass',
  'Snarl': 'Dark', 'Snipe Shot': 'Water', 'Snore': 'Normal', 'Snowscape': null,
  'Soak': null, 'Soft-Boiled': null, 'Solar Beam': 'Grass', 'Solar Blade': 'Grass',
  'Spacial Rend': 'Dragon', 'Spark': 'Electric', 'Sparkling Aria': 'Water',
  'Spectral Thief': 'Ghost', 'Speed Swap': null, 'Spicy Extract': null, 'Spikes': null,
  'Spiky Shield': null, 'Spin Out': 'Steel', 'Spirit Break': 'Fairy',
  'Spirit Shackle': 'Ghost', 'Spite': null, 'Splash': null, 'Spore': null,
  'Springtide Storm': 'Fairy', 'Stealth Rock': null, 'Steam Eruption': 'Water',
  'Steamroller': 'Bug', 'Steel Beam': 'Steel', 'Steel Roller': 'Steel', 'Steel Wing': 'Steel',
  'Sticky Web': null, 'Stomping Tantrum': 'Ground', 'Stone Axe': 'Rock', 'Stone Edge': 'Rock',
  'Stored Power': 'Psychic', 'Storm Throw': 'Fighting', 'Strange Steam': 'Fairy',
  'Strength': 'Normal', 'Strength Sap': null, 'String Shot': null, 'Struggle Bug': 'Bug',
  'Stun Spore': null, 'Substitute': null, 'Sucker Punch': 'Dark', 'Sunny Day': null,
  'Sunsteel Strike': 'Steel', 'Super Fang': 'Normal', 'Supercell Slam': 'Electric',
  'Superpower': 'Fighting', 'Surf': 'Water', 'Surging Strikes': 'Water', 'Swagger': null,
  'Swift': 'Normal', 'Switcheroo': null, 'Swords Dance': null, 'Synthesis': null,
  'Syrup Bomb': 'Grass',

  'Tachyon Cutter': 'Steel', 'Tackle': 'Normal', 'Tail Slap': 'Normal', 'Tail Whip': null,
  'Tailwind': null, 'Take Down': 'Normal', 'Take Heart': null, 'Tar Shot': null,
  'Taunt': null, 'Tearful Look': null, 'Temper Flare': 'Fire', 'Tera Blast': 'Normal',
  'Terrain Pulse': 'Normal', 'Thief': 'Dark', 'Thrash': 'Normal', 'Throat Chop': 'Dark',
  'Thunder': 'Electric', 'Thunder Cage': 'Electric', 'Thunder Fang': 'Electric',
  'Thunder Punch': 'Electric', 'Thunder Wave': null, 'Thunderbolt': 'Electric',
  'Thunderclap': 'Electric', 'Thunderous Kick': 'Fighting', 'Tickle': null, 'Tidy Up': null,
  'Topsy-Turvy': null, 'Torch Song': 'Fire', 'Torment': null, 'Toxic': null,
  'Toxic Spikes': null, 'Trailblaze': 'Grass', 'Transform': null, 'Tri Attack': 'Normal',
  'Trick': null, 'Trick Room': null, "Trick-or-Treat": null, 'Triple Arrows': 'Fighting',
  'Triple Axel': 'Ice', 'Triple Dive': 'Water', 'Trop Kick': 'Grass', 'Twin Beam': 'Psychic',
  'Twister': 'Dragon',

  'U-turn': 'Bug', 'Upper Hand': 'Fighting', 'Uproar': 'Normal',

  'V-create': 'Fire', 'Vacuum Wave': 'Fighting', 'Venoshock': 'Poison', 'Vine Whip': 'Grass',
  'Vise Grip': 'Normal', 'Volt Switch': 'Electric', 'Volt Tackle': 'Electric',

  'Water Gun': 'Water', 'Water Pledge': 'Water', 'Water Pulse': 'Water',
  'Water Shuriken': 'Water', 'Water Spout': 'Water', 'Waterfall': 'Water',
  'Wave Crash': 'Water', 'Weather Ball': 'Normal', 'Whirlpool': 'Water', 'Whirlwind': null,
  'Wicked Blow': 'Dark', 'Wide Guard': null, 'Wild Charge': 'Electric', 'Wildbolt Storm': 'Electric',
  'Will-O-Wisp': null, 'Wing Attack': 'Flying', 'Wish': null, 'Wood Hammer': 'Grass',
  'Work Up': null, 'Worry Seed': null, 'Wrap': 'Normal',

  'X-Scissor': 'Bug',

  'Yawn': null,

  'Zap Cannon': 'Electric', 'Zen Headbutt': 'Psychic', 'Zing Zap': 'Electric',
};

export default MOVE_TYPES;
